<template>
    <div class="InvoicePane paper" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>Invoices <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" /> <font-awesome-icon :icon="['fa', 'plus']" v-on:click="NewRecordShow()" class="olive-green-text pointer" /> <span v-b-tooltip.hover title="Hide/Show Filters"><font-awesome-icon :icon="ShowFilters ? 'eye' : 'eye-slash'" v-on:click="ToggleShowFilters()" class="pointer" /></span></h2>
            <form class="table-filters client-list" v-show="ShowFilters">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Invoice Status:</label>
                            <select class="form-control" v-model="Filters.Status" @change="RefreshDataTable()">
                                <option value="">All</option>
                                <option value="Paid">Paid</option>
                                <option value="Unpaid">Unpaid</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Contract:</label>
                            <select class="form-control" v-model="Filters.ContractName" @change="RefreshDataTable()">
                                <option value="">All</option>
                                <option value="33H501">Riverside Wraparound</option>
                                <option value="33JE01">Desert Wraparound</option>
                                <option value="STRTP">STRTP</option>
                                <option value="33Q8NCX">Desert Outpatient</option>
                                <option value="3328NCX">Midcounty Outpatient</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Year/Month From:</label>
                            <flat-pickr v-model="Filters.StartDate" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Year/Month To:</label>
                            <flat-pickr v-model="Filters.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        Displaying {{RowCount}} Records
                    </div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Search:</label>
                            <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div style="overflow:auto;">
            <vuetable :fields="TableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable">

                <template slot="Operations" scope="props">
                    <div class="Operations">
                        <span class="underline pointer" @click="EditRecordShow(props.rowData)">{{ props.rowData.Id.substring(24) }}</span>
                    </div>
                </template>
            </vuetable>
        </div>

        <!--MODALS-->
        <b-modal ref="modal-invoicedetail" title="Invoice Details" hide-footer>
            <b-container>
                <b-form @submit="SaveInvoice">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Contract:</label>
                                <select class="form-control" v-model="TargetRecord.ContractName" required>
                                    <option value=""></option>
                                    <option value="33H501">Riverside Wraparound</option>
                                    <option value="33JE01">Desert Wraparound</option>
                                    <option value="STRTP">STRTP</option>
                                    <option value="33Q8NCX">Desert Outpatient</option>
                                    <option value="3328NCX">Midcounty Outpatient</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Billing/Service Period FROM:</label>
                                <flat-pickr v-model="TargetRecord.ServicePeriodStart" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Billing/Service Period TO:</label>
                                <flat-pickr v-model="TargetRecord.ServicePeriodEnd" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Amount Invoiced:</label>
                                <input v-model="TargetRecord.InvoiceAmount" class="form-control" type="number" step=".01" required />
                            </div>
                            <div class="form-group">
                                <label>Date of Invoice:</label>
                                <flat-pickr v-model="TargetRecord.PostedDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Year For:</label>
                                <input v-model="TargetRecord.YearFor" class="form-control" type="number" required />
                            </div>
                            <div class="form-group">
                                <label>Month For:</label>
                                <select class="form-control" v-model="TargetRecord.MonthFor" required>
                                    <option value=""></option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Batch Numbers (separate by commas):</label>
                                <textarea v-model="TargetRecord.BatchNumbers" required class="form-control" rows="5"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Payment Received Date:</label>
                                <flat-pickr v-model="TargetRecord.PaymentPosted" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Payment Amount:</label>
                                <input v-model="TargetRecord.PaidAmount" class="form-control" type="number" step=".01" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="EditRecordCancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetRecord.Id" size="md" variant="primary" type="button" @click="DownloadInvoiceClaimsReport(TargetRecord.Id)">
                                DETAIL REPORT
                            </b-button>
                            <b-button v-if="TargetRecord.Id" size="md" variant="danger" type="button" @click="DeleteInvoice()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Vuetable from 'vuetable-2/src/components/Vuetable'

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    //mixins
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";

    export default {
        mixins: [TableScrollerSupport],
        created() {

        },
        beforeDestroy() {

        },
        props: [],
        data: function () {
            return {
                TableData: [],
                TargetRecord: {},
                InvoiceSchema: {
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                RowCount: 0,
                search: "",
                Filters: {
                    Status: "Unpaid",
                    ContractName: "",
                    StartDate: "",
                    EndDate: ""
                },
                TableOptions: {
                    Fields: [
                        {
                            name: '__slot:Operations',
                            title: 'Id',
                            sortField: 'Id',
                        },
                        {
                            name: 'Id',
                            title: 'Id',
                            visible: false
                        },
                        {
                            name: 'ContractName',
                            title: 'Contract',
                            sortField: 'ContractName'
                        },
                        {
                            name: 'YearFor',
                            title: "Year",
                            sortField: 'YearFor',
                        },
                        {
                            name: 'MonthFor',
                            title: "Month",
                            sortField: 'MonthFor',
                        },
                        {
                            name: 'PostedDate',
                            title: "Posted",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'PostedDate',
                        },
                        {
                            name: 'InvoiceAmount',
                            title: "Invoiced Amount",
                            callback: 'formatCurrency',
                            sortField: 'InvoiceAmount',
                            dataClass: 'right-text',
                            titleClass: 'right-text',
                        },
                        {
                            name: 'AvatarBatchedMatchingClaimsAmount',
                            title: "Batched Amount",
                            callback: 'formatCurrency',
                            sortField: 'AvatarBatchedMatchingClaimsAmount',
                            dataClass: 'right-text',
                            titleClass: 'right-text',
                        },
                        {
                            name: 'DiffBatchedMatchingClaimsLessInvoice',
                            title: "Batched Less Invoice",
                            callback: 'formatCurrency',
                            sortField: 'DiffBatchedMatchingClaimsLessInvoice',
                            dataClass: 'right-text',
                            titleClass: 'right-text',
                        },
                        {
                            name: 'PaidAmount',
                            title: "Paid Amount",
                            callback: 'formatCurrency',
                            sortField: 'PaidAmount',
                            dataClass: 'right-text',
                            titleClass: 'right-text',
                        },
                        {
                            name: 'DiffPaidLessInvoice',
                            title: "Invoice Less Paid",
                            callback: 'formatCurrency',
                            sortField: 'DiffPaidLessInvoice',
                            dataClass: 'right-text',
                            titleClass: 'right-text',
                        },
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetInvoices();
            },

            //////////////////////////
            //  API CONNECTIONS
            //////////////////////////

            //Get Invoices
            GetInvoices() {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Billing/Invoices", this.Filters, this.GetInvoicesSuccess, () => { }, true);
            },
            GetInvoicesSuccess(response) {
                this.TableData = response.data.data;
                this.$refs.datatable.refresh();
            },
            //Save Invoice
            SaveInvoice(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PUT", "MentalHealth/Billing/Invoices", this.TargetRecord, this.SaveInvoiceSuccess, () => { }, true);
            },
            SaveInvoiceSuccess(response) {
                this.GetInvoices();
                this.$refs["modal-invoicedetail"].hide();
            },
            //Delete Invoice
            DeleteInvoice() {
                this.$MasterAPI.ExecuteRequest("DELETE", "MentalHealth/Billing/Invoices/" + this.TargetRecord.Id, {}, this.DeleteInvoiceSuccess, () => { }, true);
            },
            DeleteInvoiceSuccess(response) {
                this.GetInvoices();
                this.$refs["modal-invoicedetail"].hide();
            },
            //Download Invoice Claims Detail Report
            DownloadInvoiceClaimsReport(invoiceID) {
                this.$MasterAPI.ExecuteFileRequest("MentalHealth/Billing/Reports/GetInvoiceClaimsReport", { InvoiceID: invoiceID });
            },

            //////////////////////////
            //  MODAL CONTROLLS
            //////////////////////////
            EditRecordShow(record) {
                this.TargetRecord = JSON.parse(JSON.stringify(record));
                this.$refs["modal-invoicedetail"].show();
            },
            NewRecordShow() {
                this.TargetRecord = JSON.parse(JSON.stringify(this.InvoiceSchema));
                this.$refs["modal-invoicedetail"].show();
            },
            EditRecordCancel() {
                this.$refs["modal-invoicedetail"].hide();
            },

            //////////////////////////
            //  MISC METHODS
            //////////////////////////
            formatDate(value, fmt = 'MM/DD/YY', defaultVal = '') {
                return (value == null)
                    ? defaultVal
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatCurrency(value) {
                if (value == null) {
                    return null;
                } else {
                    let formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    });
                    return formatter.format(value);
                }

            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.TableData);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                vm.RowCount = visibleData.length;
                return visibleData;
            }
        },
        components: {
            Vuetable,
            flatPickr
        },
        computed: {

        },
        mounted() {
            this.GetInvoices();
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>